import * as yup from 'yup';

const SELECT_OPTION = yup.object().shape({
  label: yup.string(),
  value: yup.string(),
});

export default SELECT_OPTION;
